import type { Locale } from "@eroad/types";

import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from "../constants";

/**
 * Determines a supported locale either from the provided candidate
 * or falls back to the locale based on the url domain.
 */
const getLocale = (candidateLocale?: string | undefined): Locale => {
  const localeParsed = candidateLocale?.replace("_", "-");

  if (isSupportedLocale(localeParsed)) {
    return localeParsed;
  }

  return getDefaultLocale();
};

/** Type guard */
function isSupportedLocale(localeParsed: string | undefined): localeParsed is Locale {
  return SUPPORTED_LOCALES.some((locale) => locale === localeParsed);
}

const getDefaultLocale = (): Locale => (isSupportedLocale(navigator.language) ? navigator.language : DEFAULT_LOCALE);

export { getLocale };
